import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'

import { setRoom } from '@store/actionSlices/appConfig'
import { RouteKey } from '@store/constants'
import { RootStateTypeExtra } from '@store/types'

import { Modal } from '@components/modals'

import { getQueryStringParams } from '@utilities/helper'

import RoomInput from './room-input'

interface RoomSettingsProps {
  room: string
}

function RoomSettings({ room }: RoomSettingsProps) {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()

  const [showModal, toggleModal] = useState(false)

  const [roomValue, setRoomValue] = useState(room || '')

  const handleSave = () => {
    if (room !== roomValue) {
      dispatch(setRoom(roomValue))
      history.push(RouteKey.DASHBOARD)
      window.location.reload()
    }

    toggleModal(false)
  }

  const closeModal = () => {
    setRoomValue(room)
    toggleModal(false)
  }

  const handleOnClick = () => {
    toggleModal(true)
  }

  useEffect(() => {
    setRoomValue(room)
  }, [room])

  useEffect(() => {
    const { room: roomParam } = getQueryStringParams(location.search)
    if (roomParam !== undefined) {
      dispatch(setRoom(roomParam))
    }
  }, [])

  return (
    <>
      <button
        type="button"
        className="text-default text-grayColour underline"
        onClick={handleOnClick}
      >
        Room Settings
      </button>

      <Modal
        title="Room Settings"
        isVisible={showModal}
        toggleModal={toggleModal}
        handleClose={closeModal}
        handleApply={() => {
          if (roomValue) {
            handleSave()
            return
          }

          toggleModal(false)
        }}
        applyButtonText="Apply"
      >
        <div className="flex flex-col gap-5">
          <p className="text-center text-default leading-relaxed text-fontBlackColour opacity-60">
            Change showcase room to connect
          </p>

          <RoomInput value={roomValue} onChange={setRoomValue} />
        </div>
      </Modal>
    </>
  )
}

const mapStateToProps = ({ appConfig: { room } }: RootStateTypeExtra) => ({
  room,
})

export default connect(mapStateToProps)(RoomSettings)
